<template>
    <vue-bottom-sheet ref="itemRef" @closed="emitClose" max-height="90%">
        <div v-if="isLoaded" class="dish-details">
            <svg class="close_btn" @click="close" width="32" height="32" viewBox="0 0 32 32" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect x="0.666667" y="0.666667" width="30.6667" height="30.6667" rx="15.3333" stroke="white"
                    stroke-width="1.33333" />
                <path
                    d="M20.9498 12.4625L17.4142 15.998L20.9498 19.5336C21.1373 19.7211 21.2426 19.9755 21.2426 20.2407C21.2426 20.5059 21.1373 20.7603 20.9498 20.9478C20.7622 21.1353 20.5079 21.2407 20.2426 21.2407C19.9774 21.2407 19.7231 21.1353 19.5355 20.9478L16 17.4123L12.4645 20.9478C12.2769 21.1353 12.0226 21.2407 11.7574 21.2407C11.4921 21.2407 11.2378 21.1353 11.0503 20.9478C10.8627 20.7603 10.7574 20.5059 10.7574 20.2407C10.7574 19.9755 10.8627 19.7211 11.0503 19.5336L14.5858 15.998L11.0503 12.4625C10.8627 12.275 10.7574 12.0206 10.7574 11.7554C10.7574 11.4902 10.8627 11.2358 11.0503 11.0483C11.2378 10.8608 11.4921 10.7554 11.7574 10.7554C12.0226 10.7554 12.2769 10.8608 12.4645 11.0483L16 14.5838L19.5355 11.0483C19.7231 10.8608 19.9774 10.7554 20.2426 10.7554C20.5079 10.7554 20.7622 10.8608 20.9498 11.0483C21.1373 11.2358 21.2426 11.4902 21.2426 11.7554C21.2426 12.0206 21.1373 12.275 20.9498 12.4625Z"
                    fill="white" />
            </svg>
            <div v-if="!!computedDish.image" class="dish-details__image">
                <img :src="computedDish.image" :alt="`Image of ${computedDish.name}`">
            </div>
            <div class="dish-details__content">
                <div class="dish-details__content-title">
                    <!--<small>Kombo menu</small>-->
                    <h3>{{ computedDish.name }}</h3>
                </div>
                <p class="dish-details__content-text-description" v-html="computedDish.description">
                </p>
                <div class="dish-details__content-description">
                    <ul>
                        <li v-if="Boolean(computedDish.is_vegetarian)">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M22.5006 23.385C20.44 25.2335 17.7682 26.254 15 26.25C8.78687 26.25 3.75 21.2131 3.75 15C3.75 12.0387 4.89375 9.345 6.76437 7.33563L8.62063 9.19187C8.7385 9.30572 8.89638 9.36872 9.06025 9.3673C9.22412 9.36587 9.38088 9.30014 9.49676 9.18426C9.61264 9.06838 9.67837 8.91162 9.6798 8.74775C9.68122 8.58388 9.61822 8.426 9.50437 8.30813L7.66563 6.46937C9.70442 4.71138 12.3079 3.74607 15 3.75C21.2131 3.75 26.25 8.78687 26.25 15C26.25 17.8813 25.1663 20.5106 23.385 22.5006L19.7638 18.88C19.9203 18.4234 20.0002 17.944 20 17.4613V16.25C20 16.1143 19.9558 15.9824 19.8742 15.874C19.7926 15.7657 19.6779 15.6868 19.5475 15.6494C19.8453 15.0469 20.0002 14.3839 20 13.7119V12.5C20 12.3952 19.9737 12.2921 19.9234 12.2002C19.8732 12.1083 19.8006 12.0304 19.7125 11.9739C19.6243 11.9173 19.5233 11.8838 19.4188 11.8765C19.3143 11.8691 19.2096 11.8882 19.1144 11.9319L19.0769 11.9487C19.2739 11.4431 19.375 10.9052 19.375 10.3625V9.375C19.375 9.27376 19.3503 9.17405 19.3032 9.08444C19.2561 8.99484 19.1879 8.91802 19.1045 8.86059C19.0212 8.80316 18.9251 8.76685 18.8246 8.75477C18.7241 8.74269 18.6221 8.75521 18.5275 8.79125L17.1925 9.29937C17.14 9.31924 17.0879 9.34007 17.0362 9.36188C17.0129 8.23807 16.6002 7.15721 15.8687 6.30375L15.475 5.84312C15.4163 5.77451 15.3435 5.71943 15.2615 5.68166C15.1795 5.64389 15.0903 5.62433 15 5.62433C14.9097 5.62433 14.8205 5.64389 14.7385 5.68166C14.6565 5.71943 14.5837 5.77451 14.525 5.84312L14.1313 6.30312C13.3993 7.15683 12.9864 8.23819 12.9631 9.3625C12.9116 9.34071 12.8598 9.31987 12.8075 9.3L11.4725 8.79062C11.3778 8.75457 11.2758 8.74205 11.1753 8.75416C11.0747 8.76627 10.9786 8.80264 10.8952 8.86014C10.8118 8.91764 10.7437 8.99454 10.6966 9.08423C10.6495 9.17392 10.6249 9.27371 10.625 9.375V10.3625C10.625 10.9163 10.7294 11.4525 10.9225 11.9487L10.8856 11.9319C10.7904 11.8882 10.6857 11.8691 10.5812 11.8765C10.4767 11.8838 10.3757 11.9173 10.2875 11.9739C10.1994 12.0304 10.1268 12.1083 10.0766 12.2002C10.0263 12.2921 9.99999 12.3952 10 12.5V13.7119C9.9998 14.3839 10.1547 15.0469 10.4525 15.6494C10.3222 15.6869 10.2076 15.7658 10.1259 15.8741C10.0443 15.9824 10.0001 16.1144 10 16.25V17.4619C10.0002 18.2989 10.2404 19.1183 10.6923 19.8229C11.1442 20.5274 11.7887 21.0876 12.5494 21.4369L14.375 22.2762V23.75H15.625V22.2756L17.4506 21.4375C18.1297 21.1259 18.7176 20.6454 19.1581 20.0419L22.5006 23.385ZM27.5 15C27.5 21.9037 21.9037 27.5 15 27.5C8.09625 27.5 2.5 21.9037 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5C21.9037 2.5 27.5 8.09625 27.5 15ZM15 7.21375C15.3365 7.63529 15.5742 8.12697 15.6955 8.65256C15.8167 9.17815 15.8185 9.72426 15.7006 10.2506C15.4294 10.5144 15.1944 10.8113 15 11.1344C14.8055 10.8109 14.57 10.5138 14.2994 10.2506C14.1815 9.72426 14.1833 9.17815 14.3045 8.65256C14.4258 8.12697 14.6635 7.63529 15 7.21375ZM14.375 13.4681V13.3881C14.3751 12.7547 14.1827 12.1362 13.8232 11.6146C13.4638 11.093 12.9544 10.693 12.3625 10.4675L11.875 10.2819V10.3619C11.8749 10.9953 12.0673 11.6138 12.4268 12.1354C12.7862 12.657 13.2956 13.057 13.8875 13.2825L14.375 13.4681ZM15.625 13.4681L16.1125 13.2825C16.7044 13.057 17.2138 12.657 17.5732 12.1354C17.9327 11.6138 18.1251 10.9953 18.125 10.3619V10.2819L17.6375 10.4675C17.0456 10.693 16.5362 11.093 16.1768 11.6146C15.8173 12.1362 15.6249 12.7547 15.625 13.3881V13.4681ZM15.625 16.3169C15.625 15.4594 16.125 14.68 16.9037 14.3225L18.75 13.475V13.7119C18.7499 14.3097 18.5784 14.895 18.2557 15.3983C17.933 15.9016 17.4727 16.3017 16.9294 16.5513L15.625 17.15V16.3169ZM12.5544 14.0731C13.0978 14.3228 13.5583 14.7231 13.881 15.2266C14.2037 15.7301 14.3752 16.3157 14.375 16.9137V17.1512L13.0706 16.5519C12.5273 16.3023 12.067 15.9022 11.7443 15.3989C11.4216 14.8956 11.2501 14.3104 11.25 13.7125V13.475L12.5544 14.0731ZM14.375 20.9V20.6637C14.375 20.0658 14.2035 19.4804 13.8808 18.977C13.5581 18.4736 13.0978 18.0733 12.5544 17.8237L11.25 17.225V17.4619C11.2501 18.0597 11.4216 18.645 11.7443 19.1483C12.067 19.6516 12.5273 20.0517 13.0706 20.3012L14.375 20.9ZM15.625 20.9L16.9294 20.3012C17.4726 20.0518 17.9328 19.6517 18.2555 19.1485C18.5782 18.6454 18.7498 18.0602 18.75 17.4625V17.225L16.9037 18.0731C16.5223 18.2484 16.199 18.5293 15.9724 18.8827C15.7457 19.2361 15.6252 19.6471 15.625 20.0669V20.9Z"
                                    fill="#656565" />
                            </svg>
                        </li>
                        <li v-if="Boolean(computedDish.is_spicy)">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M26.25 4.6875V2.8125C24.3862 2.8125 22.9312 3.33281 21.9328 4.35C21.438 4.85992 21.0714 5.48006 20.8631 6.15938C20.3869 5.83125 19.8337 5.625 19.2187 5.625C16.8534 5.625 15.9591 7.5075 15.9375 8.78906C15.937 9.00423 15.9298 9.21934 15.9159 9.43406C15.2859 11.2969 14.0625 10.0622 14.0625 7.5C11.0409 10.7081 14.2969 11.8912 12.4406 13.7475C12.045 14.1431 11.1 14.2969 10.5094 13.5722C9.73031 12.645 11.3156 11.1216 9.81469 9.9825C10.0894 11.6972 8.7675 11.3419 8.32031 10.9753C7.73812 10.4991 6.67969 9.45188 8.4375 6.5625C6.63937 7.38281 5.55562 9.04875 5.625 10.3125C5.8125 13.6266 10.935 16.5047 8.86594 18.4387C7.8225 19.4166 5.77219 18.0947 6.5625 15.9375C5.57812 16.4391 4.42031 17.6334 4.79062 19.4906C5.04562 20.775 6.91312 23.6719 3.75 25.3125L3.79031 25.3237L3.70969 27.1875C3.77156 27.1912 4.02469 27.1987 4.43156 27.1987C7.06781 27.1987 16.1934 26.7919 21.8119 21.4125C24.7556 18.5925 26.25 14.8575 26.25 10.3125C26.25 9.01594 25.6603 6.5625 23.4375 6.5625C23.1628 6.5625 22.9069 6.6 22.665 6.65813C22.7709 6.34313 22.9537 5.98312 23.2687 5.66156C23.9062 5.0175 24.9056 4.6875 26.25 4.6875ZM23.4375 8.4375C24.3234 8.4375 24.375 10.2975 24.375 10.3125C24.375 14.3222 23.0747 17.5997 20.5191 20.0531C16.3697 24.0309 9.8325 25.0163 6.28406 25.2506C7.14844 25.0528 8.18812 24.6497 9.32719 23.8809C14.8134 20.8744 17.6991 13.7841 17.805 9.06375H17.8125V8.80781C17.8162 8.5875 17.9044 7.5 19.2187 7.5C20.0203 7.5 20.625 8.63906 20.625 9.375H22.5C22.5 8.97188 22.5984 8.4375 23.4375 8.4375Z"
                                    fill="#656565" />
                            </svg>
                        </li>
                        <li v-if="Boolean(computedDish.is_gluten_free)">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.75 13.8287C15.6625 17.0625 12.5738 25 12.5738 25C12.5738 25 8.16125 13.8287 3.75 11.25"
                                    stroke="#656565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M25.62 6.97127L26.1525 12.5013C26.4975 16.0888 23.8087 19.2825 20.2212 19.6288C16.7012 19.9663 13.5125 17.3938 13.1737 13.8738C13.0931 13.0367 13.178 12.192 13.4238 11.3878C13.6697 10.5836 14.0715 9.83577 14.6064 9.1869C15.1412 8.53803 15.7987 8.00088 16.5412 7.60613C17.2837 7.21139 18.0967 6.96678 18.9337 6.88627L24.8287 6.31877C24.9236 6.30964 25.0192 6.31927 25.1103 6.34712C25.2014 6.37497 25.2861 6.42049 25.3596 6.48109C25.433 6.54168 25.4939 6.61616 25.5386 6.70027C25.5832 6.78438 25.6109 6.87647 25.62 6.97127Z"
                                    stroke="#656565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </li>
                        <li v-if="Boolean(computedDish.is_low_calorie)">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="14.5" cy="15.5" r="11.75" stroke="#656565" stroke-width="1.5" />
                                <path
                                    d="M7.44141 18V12.0547H8.58203V18H7.44141ZM10.1484 18L8.82812 16.1328L9.67969 15.4492L11.4961 18H10.1484ZM8.50391 16.6406L8.46484 15.3984H8.65234L10.0898 13.6992H11.3828L9.61328 15.6523L9.00391 16.1094L8.50391 16.6406ZM13.8516 18.0898C13.4036 18.0898 13.0221 18.0026 12.707 17.8281C12.3945 17.651 12.1562 17.3958 11.9922 17.0625C11.8281 16.7266 11.7461 16.3203 11.7461 15.8438V15.8359C11.7461 15.362 11.8281 14.9596 11.9922 14.6289C12.1562 14.2982 12.3945 14.0456 12.707 13.8711C13.0221 13.694 13.4036 13.6055 13.8516 13.6055C14.2318 13.6055 14.5586 13.6706 14.832 13.8008C15.1055 13.931 15.3216 14.1146 15.4805 14.3516C15.6393 14.5885 15.7357 14.8672 15.7695 15.1875V15.1992H14.7109L14.707 15.1914C14.668 14.9831 14.5768 14.8164 14.4336 14.6914C14.293 14.5638 14.1003 14.5 13.8555 14.5C13.6523 14.5 13.4792 14.5521 13.3359 14.6562C13.1953 14.7578 13.0885 14.9076 13.0156 15.1055C12.9427 15.3034 12.9062 15.5469 12.9062 15.8359V15.8438C12.9062 16.1328 12.9427 16.3789 13.0156 16.582C13.0911 16.7826 13.1992 16.9349 13.3398 17.0391C13.4805 17.1432 13.6523 17.1953 13.8555 17.1953C14.0898 17.1953 14.2773 17.1406 14.418 17.0312C14.5586 16.9219 14.6536 16.7578 14.7031 16.5391L14.7109 16.5273L15.7656 16.5234V16.5508C15.724 16.8607 15.6237 17.1315 15.4648 17.3633C15.306 17.5951 15.0911 17.7747 14.8203 17.9023C14.5495 18.0273 14.2266 18.0898 13.8516 18.0898ZM17.832 18.0664C17.5612 18.0664 17.319 18.0143 17.1055 17.9102C16.8945 17.8034 16.7292 17.6536 16.6094 17.4609C16.4896 17.2656 16.4297 17.0378 16.4297 16.7773V16.7695C16.4297 16.5117 16.4935 16.2904 16.6211 16.1055C16.7513 15.9206 16.9401 15.776 17.1875 15.6719C17.4375 15.5651 17.7409 15.5013 18.0977 15.4805L19.6992 15.3828V16.0781L18.2695 16.1719C18.0247 16.1849 17.8424 16.237 17.7227 16.3281C17.6029 16.4193 17.543 16.543 17.543 16.6992V16.707C17.543 16.8711 17.6055 17 17.7305 17.0938C17.8555 17.1875 18.0169 17.2344 18.2148 17.2344C18.3919 17.2344 18.5495 17.1992 18.6875 17.1289C18.8255 17.0586 18.9349 16.9635 19.0156 16.8438C19.0964 16.7214 19.1367 16.5846 19.1367 16.4336V15.0625C19.1367 14.875 19.0742 14.7318 18.9492 14.6328C18.8268 14.5312 18.6484 14.4805 18.4141 14.4805C18.2083 14.4805 18.0404 14.5156 17.9102 14.5859C17.7826 14.6536 17.6966 14.7513 17.6523 14.8789L17.6445 14.8945H16.5898L16.5938 14.8594C16.625 14.6068 16.7201 14.3867 16.8789 14.1992C17.0404 14.0117 17.2565 13.8659 17.5273 13.7617C17.8008 13.6576 18.1172 13.6055 18.4766 13.6055C18.8568 13.6055 19.1797 13.6641 19.4453 13.7812C19.7109 13.8958 19.9128 14.0625 20.0508 14.2812C20.1914 14.4974 20.2617 14.7578 20.2617 15.0625V18H19.1367V17.4297H19.0664C18.9935 17.5625 18.8958 17.6771 18.7734 17.7734C18.6536 17.8672 18.513 17.9401 18.3516 17.9922C18.1927 18.0417 18.0195 18.0664 17.832 18.0664ZM21.418 18V12.0547H22.5586V18H21.418Z"
                                    fill="#656565" />
                            </svg>
                        </li>
                    </ul>
                    <span v-if="computedDish.weight > 0">{{ computedDish.weight }} g</span>
                </div>
                <div class="dish-details__content-footer">
                    <span>{{ `${computedDish.price * itemCount} zł` }} </span>
                    <VItemCounter v-if="orderIsAvailable(computedDish)" :id="computedDish.id" :value="itemCount"
                        @update:value="value => itemCount = value" />
                </div>
                <VButton v-on:click.native="addToCart" class="place_order" v-if="orderIsAvailable(computedDish)">
                    {{ $t("Add to cart") }}
                </VButton>
            </div>
        </div>
    </vue-bottom-sheet>
</template>

<script>
import vueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import VItemCounter from "@/components/ui/VItemCounter.vue";
import VButton from "@/components/ui/VButton.vue";

export default {
    name: "VDishDetails",
    components: {
        vueBottomSheet,
        VButton,
        VItemCounter
    },
    props: {
        value: { type: Boolean, required: true }, //showFullItem
        dishId: { type: [String, Number], default: null },
        dish: { type: [Object], default: null }
    },
    emits: ['input'],
    data() {
        return {
            itemCount: 1,
            isLoaded: false,
            toastOptions: {
                position: "top-center",
                timeout: 2000,
                closeOnClick: true
            }
        }
    },
    mounted() {
        if (this.dish) {
            this.isLoaded = true;
        }
        // else {
        //     this.$store.dispatch('menuStore/GET_DISH_ITEM', this.dishId)
        //         .then(loaded => {
        //             this.isLoaded = loaded;
        //         });
        // }
    },
    beforeDestroy() {
        this.$store.commit('menuStore/SET_DISH_ITEM', null)
    },
    computed: {
        computedDish() {
            return this.dish ? this.dish : this.$store.getters['menuStore/getDish']
            // return this.$store.getters['menuStore/getDish']
        }
    },
    watch: {
        value(newVal) {
            if (newVal) {
                this.open();
            }
        }
    },
    methods: {
        formatPrice(price) {
            return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(price)
        },
        addToCart() {
            let item = {
                ...this.computedDish, count: this.itemCount, product: this.computedDish
            }

            if (this.$store.getters['getIsModeWMM']) {
                this.$store.dispatch('cartStore/SET_ITEM_TO_CART', item).then(resp => {
                    if (resp) {
                        this.$toast.success(this.$t('Added to cart'), this.toastOptions);
                    }
                })
            } else {
                // this.$store.commit('addToCart', item);
                this.$store.commit('cartStore/ADD_TO_CART', item);
                this.$toast.success(this.$t('Added to cart'), this.toastOptions);
            }

            this.close();
        },
        orderIsAvailable(computedDish) {
            var locale = this.$store.getters['getCompanyData'].locale;
            // var tableData = this.$store.getters['getTableData'];
            // var table = tableData ? tableData.id : false;
            var available_for_order = computedDish !== null && computedDish.available_for_order;

            return available_for_order
                && (locale.activePaymentCredentials || this.$store.getters['getIsModeHOT'] || this.$store.getters['getIsModeSOT'])
                // && ((locale.pos_terminal_enabled && !locale.posConnection) || locale.posConnection)
                && locale.pos_terminal_enabled
                // && locale.posConnection
                && (this.$store.getters['getCartEnabled'])
            // && table;
        },
        open() {
            this.$refs.itemRef.open();
        },
        close() {
            this.$refs.itemRef.close();
            this.emitClose();
        },
        emitClose() {
            this.$emit('input', false);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

small,
h3,
p,
ul,
li {
    margin: 0;
    padding: 0;
}

ul li {
    list-style: none;
}

::v-deep .bottom-sheet__pan {
    display: none;
}

::v-deep .bottom-sheet__content {
    touch-action: none !important;
    -webkit-overflow-scrolling: touch;
}

.dish-details {

    .close_btn {
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10;
        border-radius: 50%;
        background: #c9c9c9;
    }

    &__image {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 400px;

        border-radius: 14px 14px 0 0;

        &>img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: brightness(80%);
        }
    }

    &__content {
        padding: 24px;

        display: flex;
        flex-direction: column;
        gap: 10px;

        &-title {
            display: flex;
            flex-direction: column;

            &>small,
            h3 {
                font: {
                    size: 22px;
                    weight: 700;
                }

                ;
                line-height: 30px;
                color: $color_black;
                letter-spacing: -0.5px;
            }
        }

        &>p {
            color: $color_dove_gray;

            font: {
                weight: 500;
                size: 16px;
            }

            ;
            line-height: 20px;
            letter-spacing: 0.61px;
        }

        &-text-description {
            color: $color_dove_gray;

            font: {
                weight: 500;
                size: 16px;
            }

            ;
            line-height: 20px;
            letter-spacing: 0.61px;
            white-space: pre-line;
        }

        &-description {
            height: 34px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &>ul {
                display: flex;
                align-items: center;
                gap: 10px;
            }

            &>span {
                font: {
                    size: 16px;
                    weight: 400;
                }

                ;
                color: $color_dove_gray;
            }


        }

        &-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &>span {
                margin-top: 7px;
                color: $color_black;

                font: {
                    size: 22px;
                    weight: 700;
                }

                ;
                line-height: 27px;
                letter-spacing: 0.1px;
            }
        }

        .btn {
            margin-top: 30px;
        }

    }
}
</style>
